import { render, staticRenderFns } from "./onBeforeUpload-editor.vue?vue&type=template&id=4b971f56&scoped=true"
import script from "./onBeforeUpload-editor.vue?vue&type=script&lang=js"
export * from "./onBeforeUpload-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b971f56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b971f56')) {
      api.createRecord('4b971f56', component.options)
    } else {
      api.reload('4b971f56', component.options)
    }
    module.hot.accept("./onBeforeUpload-editor.vue?vue&type=template&id=4b971f56&scoped=true", function () {
      api.rerender('4b971f56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/event-handler/onBeforeUpload-editor.vue"
export default component.exports